export default __webpack_public_path__ + "static/media/CivilEng_BG-01-4.38c40f9f.png";